import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useAuth } from '~src/hooks/useAuth';
import { routes } from '../../routes/routes';

export function ProtectedRoute({ children }) {
  const router = useRouter();
  const { status, authStatuses, enrollmentPhase, enrollmentPhases, signout } = useAuth();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    if (status === authStatuses.SIGNED_OUT) {
      // store where we are now, to redirect after login.
      let currentLocation = window.location.href;
      localStorage.setItem('post_login_redirect', currentLocation);

      // redirect to login
      return router.push(routes.login.path);
    } else if (
      status === authStatuses.SIGNED_IN &&
      enrollmentPhase === enrollmentPhases.INCOMPLETE
    ) {
      return router.push({ pathname: routes.agreements.path });
    } else if (status === authStatuses.SIGNED_IN) {
      setIsVerified(true);
    }
  }, [router, status, authStatuses, enrollmentPhase, enrollmentPhases, signout]);

  if (isVerified) {
    return children;
  } else {
    return null;
  }
}
